import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { CampaignService } from '../../store/services/campaign.service';
import { ICampaign } from '../../store/models/campaigns.model';
import { ISelectItem } from '../../store/models/select.model';
import * as moment from 'moment';
import { MatRadioChange } from '@angular/material/radio';
import { DIALOG_COMPONENT, DialogComponent } from '../../shared/ui/dialog/dialog.component';

@Component({
  selector: 'app-send-to-campaign',
  templateUrl: './send-to-campaign.component.html',
  styleUrls: ['./send-to-campaign.component.scss'],
})
export class SendToCampaignComponent implements OnInit {
  inputForm: FormGroup;

  componentReady = false;

  activeCampaigns: ICampaign[];

  constructor(
    private readonly campaignService: CampaignService,
    @Inject(DIALOG_COMPONENT) private readonly dialogComponent: DialogComponent,
  ) {
  }

  get choice(): string {
    return this.inputForm.get('choice').value;
  }

  get campaignId(): AbstractControl {
    return this.inputForm.get('campaign_id');
  }

  get startDate(): AbstractControl {
    return this.inputForm.get('start_date');
  }

  changeChoice($event: MatRadioChange): void {
    this.dialogComponent.setButtonsText($event.value === '1' ? 'Save' : 'Send', 0);

    if ($event.value === '1') {
      this.inputForm.get('campaign_id').removeValidators([Validators.required]);
      this.inputForm.get('start_date').removeValidators([Validators.required]);
      this.inputForm.get('campaign_id').updateValueAndValidity();
      this.inputForm.get('start_date').updateValueAndValidity();
    } else {
      this.inputForm.get('campaign_id').setValidators([Validators.required]);
      this.inputForm.get('start_date').setValidators([Validators.required]);
      this.inputForm.get('campaign_id').updateValueAndValidity();
      this.inputForm.get('start_date').updateValueAndValidity();
    }

    this.inputForm.updateValueAndValidity();
  }

  ngOnInit(): void {
    this.campaignService.getActiveCampaigns(null, {
      active: 'true',
      published: 'true',
      no_campaign: 'true',
    }).subscribe(result => {
      this.activeCampaigns = result.items;
      this.inputForm.addControl('choice', new FormControl('0', []));
      this.inputForm.addControl(
        'campaign_id',
        new FormControl('', [Validators.required]),
      );
      this.inputForm.addControl(
        'start_date',
        new FormControl('', [Validators.required]),
      );
      this.componentReady = true;
    });
  }

  getCampaignsSelectItems(): ISelectItem[] {
    return this.activeCampaigns.map(c => ({
      label: c.campaign_name,
      value: c.campaign_id,
    }));
  }

  getStartDate() {
    return moment().startOf('day').toDate();
  }
}
